"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_jss_1 = __importDefault(require("react-jss"));

exports.default = react_jss_1.default({
  bounce: {
    animation: 'grow 1s linear infinite'
  },
  first: {
    fill: '#69A7D8',
    animation: 'bounce 1s linear infinite'
  },
  second: {
    fill: '#EE7F4D',
    animation: 'bounce 1s linear infinite',
    animationDelay: '.2s'
  },
  third: {
    fill: '#E35082',
    animation: 'bounce 1s linear infinite',
    animationDelay: '.4s'
  },
  '@keyframes grow': {
    '0%': {
      transform: 'scale(2)'
    },
    '50%': {
      transform: 'scale(3)'
    },
    '100%': {
      transform: 'scale(2)'
    }
  },
  '@keyframes bounce': {
    '0%': {
      transform: 'translateY(0)'
    },
    '25%': {
      transform: 'translateY(-25px)'
    },
    '75%': {
      transform: 'translateY(25px)'
    },
    '100%': {
      transform: 'translateY(0)'
    }
  }
});